/**
 * Вспомогательные функции
 */

/**
 * Записать cookie
 *
 * @param name
 * @param value
 * @param options
 */
window.setCookie = function (name, value, options) {
    options = options || {};

    let expires = options.expires;

    if (expires && typeof expires === 'number') {
        let d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = name + "=" + value;

    for (let propName in options) {

        updatedCookie += "; " + propName;

        if (options.hasOwnProperty(propName) === false){
            continue;
        }

        let propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie + "; path=/";
};

/**
 * Получить cookie
 *
 * @param cookieName
 * @returns {string}
 */
window.getCookie = function (cookieName) {
    if (document.cookie.length > 0) {
        let cookieStart = document.cookie.indexOf(cookieName + '=');

        if (cookieStart !== -1) {

            cookieStart = cookieStart + cookieName.length + 1;
            let cookieEnd = document.cookie.indexOf(';', cookieStart);
            if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
            }
            return unescape(document.cookie.substring(cookieStart, cookieEnd));
        }
    }

    return '';
};

/**
 * Конвертация объекта в массив
 *
 * @param obj
 * @returns {Array}
 */
window.convertObjToArr = function (obj) {

    let arr = [];

    Object.keys(obj).map(function (key) {
        arr[Number(key)] = obj[key];
    });

    return arr;
};

/**
 * Количество элементов в объекте
 *
 * @param obj
 * @returns {number}
 */
window.count = function (obj) {

    let count = 0;

    for (let prs in obj) {
        if (obj.hasOwnProperty(prs)) {
            count++;
        }
    }
    return count;
};


/**
 * Объединить массивы
 *
 * @param array
 * @param mergeArray
 * @returns {*}
 */
window.merge = function (array, mergeArray) {

    mergeArray.forEach(function (element, index) {
        array[index] = element;
    });

    return array;
};